import type { MenuItemDescriptorApp } from "@components/Actions/CatalogActions/buildCatalogMenu";
import type { CatalogActionsContextValue } from "@components/Actions/CatalogActions/CatalogActionsContext";
import CatalogItem from "@components/Actions/CatalogItems/Base";
import { PlatformServiceNew } from "@core-ui/PlatformService";
import { DropdownMenuSeparator } from "@ui-kit/Dropdown";
import { Icon } from "@ui-kit/Icon";
import { tui } from "../locale";
import { reloadsFor } from "../store/useCanReload";
import { useWorkspaceToolsActions } from "../store/useWorkspaceToolsActions";
import { useEnabledToolsState } from "../store/useWorkspaceToolsStore";

/**
 * One item that follows the tools state, so a menu opened before the state arrives still gains its entry. Only the
 * tools catalog has one: an ordinary catalog leads into the tools from the account menu.
 */
export const workspaceToolsCatalogMenu = ({
	catalogName,
	limitedActions,
	canEditContent,
}: CatalogActionsContextValue): MenuItemDescriptorApp[] => [
	{
		id: "workspace-tools",
		component: () => <WorkspaceToolsCatalogItems catalogName={catalogName} />,
		// The tools catalog is the one with limited actions, and its only entry, Reload, goes where the command does.
		visible: limitedActions && reloadsFor(PlatformServiceNew.isDocPortal, canEditContent),
	},
];

const WorkspaceToolsCatalogItems = ({ catalogName }: { catalogName: string }) => {
	const state = useEnabledToolsState();
	if (state?.catalogName !== catalogName) return null;

	return (
		<>
			<DropdownMenuSeparator />
			<ReloadToolsItem />
		</>
	);
};

const ReloadToolsItem = () => {
	const { reload } = useWorkspaceToolsActions();

	return (
		<CatalogItem
			renderLabel={(Item) => (
				<Item onSelect={() => void reload()}>
					<div className="flex items-center gap-2" data-testid="workspace-tools-reload">
						<Icon icon="refresh-cw" />
						{tui("reload")}
					</div>
				</Item>
			)}
		/>
	);
};
